var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoReportsWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.948,
    height: 30.183,
    viewBox: "0 0 32.948 30.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4427",
    "data-name": "Group 4427",
    transform: "translate(9589 3627.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4338",
    "data-name": "Group 4338",
    transform: "translate(-9569.282 -3610.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4337",
    "data-name": "Group 4337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M206.2,175H194.781a.9.9,0,0,0-.629,1.554l8.041,8.041a.908.908,0,0,0,1.418-.111,14.44,14.44,0,0,0,3.477-8.416.7.7,0,0,0,.019-.162A.905.905,0,0,0,206.2,175Z",
    transform: "translate(-193.875 -175.001)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4340",
    "data-name": "Group 4340",
    transform: "translate(-9572.728 -3627.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4339",
    "data-name": "Group 4339",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M160.9,13.594a.907.907,0,0,0-.9.906V27.19a.905.905,0,0,0,.9.909H173.6a.908.908,0,0,0,.906-.909A14.53,14.53,0,0,0,160.9,13.594Z",
    transform: "translate(-160 -13.594)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4342",
    "data-name": "Group 4342",
    transform: "translate(-9589 -3625.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4341",
    "data-name": "Group 4341",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M24.151,49l-9.363-9.363A.9.9,0,0,1,14.534,39l0-13.225a.9.9,0,0,0-.9-.9A14.532,14.532,0,1,0,24.091,50.323a.9.9,0,0,0,.321-.69A.907.907,0,0,0,24.151,49Z",
    transform: "translate(0 -24.875)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReportsWt);
export default __webpack_public_path__ + "static/media/ico_reports_wt.81aee8c9fc42e407e7ebf0875d0d25f2.svg";
export { ForwardRef as ReactComponent };